module.exports = __webpack_public_path__ + "static/media/paucartambo.68a8731a.webp";